// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,
  storageBucket: 'https://assets-pre.clicktecdr.com',
  urlAvatar: 'assets/images/agent_avatar/',
  backendEndpoint: 'https://back-pre.clicktecdr.com',
};

// export const environment = {
//   production: false,
//   storageBucket: 'https://clicktec-dev-temporal.s3-eu-west-1.amazonaws.com',
//   backendEndpoint: 'https://phzgp2q005.execute-api.eu-west-1.amazonaws.com/pre',
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
